export default __webpack_public_path__ + "static/IJBStreetwearSinceRed-9186babc44b0070c79eaa753667fed21.png";